module.exports = __webpack_public_path__ + "static/io-23eab6279ef89ed8fac7b9c8cbe85a4f.svg";